// Screen `api` — design/screens/ApiWebhooks.dc.html — owner: S8.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { type ApiTab, ApiPage } from '../../../features/integrations/ApiPage';

const Search = z.object({
  tab: z.enum(['keys', 'webhooks', 'reference', 'mcp', 'usage']).optional().catch(undefined),
});

export const Route = createFileRoute('/_settings/settings/api')({
  validateSearch: (search: Record<string, unknown>): { tab?: ApiTab | undefined } => Search.parse(search),
  component: ApiRoute,
});

function ApiRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ApiPage
      tab={tab ?? 'keys'}
      onTab={(next) => void navigate({ search: next === 'keys' ? {} : { tab: next }, replace: true })}
    />
  );
}
